import gettext from '@sdk/lang/gettext';
import { ModalState } from '@sdk/components/ui/modal/useModalState';

import { DeleteConfirmModal } from '@web/components/DeleteConfirmModal/DeleteConfirmModal';

import { useLeaveConversationModal } from './leaveConversationModal.hooks';

type Props = {
  modalState: ModalState;
};

export const LeaveConversationModal = ({ modalState }: Props) => {
  const { onSubmit } = useLeaveConversationModal();

  return (
    <DeleteConfirmModal
      modalState={modalState}
      title={gettext('Please confirm')}
      description={gettext('Are you sure you want to leave this conversation?')}
      onSubmit={onSubmit}
    />
  );
};
